import React,{ useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import * as ShipConstants from '../../../Global/Constants';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import http from '../../../services/http';
import { callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as actions from '../../../store/actions';
import { connect } from 'react-redux';
import FormInputFields from '../../../Components/FormInputFields';
import {formInputFieldsKeyRef} from '../ShippingFunction';
import { setArrayIndexes, isSet } from '../../../Utils/CommonFunctions';
import Icons from '../../../Components/Icons/Icons';
import ArrayElement from '../../../Components/ArrayElement';
// import {ErrorDefaultFields} from '../../../Components/ArrayElement/ErrorDefaultFields';
import $ from 'jquery';
import WindowMapFields from '../../StepsFlowContainer/StepsCustomize/StepsSidebar/Variables/WindowMapFields';
import HeaderTabs from '../../../Components/UI/HeaderTabs';
import { ErrorBlock } from '../../../hoc/FormInput';

const CreateNew = (props) => {
    const [windowFields,setWindowFields] = useState({});
    // const [formFields, setFormFields] = useState({
    //     variable_name : '',
    //     variable_type : 'LOCAL',
    //     is_constant : false,
    //     constant_value : null,
    //     fieldtype_id : '',
    //     ratesheet_id : '',
    //     fieldtype_name : '',
    //     max_value : 1,
    //     decimal_places : 0,
    //     fields: [],
    //     function_type:'RATES',
    //     is_response:false,
    //     is_request:false,
    // })

    const [payload, setPayload] = useState({
        variable_name : '',
        variable_type : 'LOCAL',
        is_constant : false,
        constant_value : null,
        fieldtype_id : '',
        ratesheet_id : '',
        fieldtype_name : '',
        max_value : 1,
        decimal_places : 0,
        fields: [],
        function_type:'RATES',
        is_response:false,
        is_request:true,
        field_expression:'',
    })

    const [errorDefaultFields, setErrorDefaultFields] = useState([
    {
      "name": "type",
      "field_type_id": "",
      "fieldtype_name": "",
      "indexes": ",0",
      "max_value": 0,
      "decimal_places": 0,
      "fields": [],
      "field_expression": "",
      "displayPosition": 1
    },
    {
      "name": "message",
      "field_type_id": "",
      "fieldtype_name": "",
      "indexes": ",1",
      "max_value": 0,
      "decimal_places": 0,
      "fields": [],
      "field_expression": "",
      "displayPosition": 2
    }
    ])

    const [isEdit, setIsEdit] = useState(false);
    const curState = props.curState;
    const rateSheets = curState.rateSheets;
    const variablesAndFields = curState.variablesAndFields;
    const [violations,setViolations]=useState([]);
    console.log('violations',violations);

    useEffect( ()=>{
        if(props.curState.editData) {
            const list = {...payload}
            let data = props.curState.editData;
            setArrayIndexes(data);
            if(isSet(props.curState.editData.fields,null)!==null){
                setPayload(props.curState.editData);
            }else{
                setPayload({...props.curState.editData,fields:[]});
            }
            //setPayload(props.curState.editData);
            setIsEdit(true);
        }
    }, [props.triggerEffect]);

    const arrayChangeHandler = (e,ind) => {
        const {name,value} = e.target;
        const data = {...payload};
        let indArr = ind.split(",");
        let cleanArr = indArr.filter((a) => a);
        let str = 'data.';
        cleanArr.map((item,iInd) => {
            str += cleanArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
        })
        let dat = eval(str);
        if(name === "field_type_id") {
            const fieldName = e.target.selectedOptions[0].text;
            dat["fieldtype_name"]=fieldName;
            dat["field_expression"]="";
        }
        dat[name]=value;
        setPayload(data);
    }

    const addArrayRow = (ind='') => {
        console.log(ind);
        const data = {...payload};
        const addArrayElementRow =  {
                "name": "",
                "field_type_id": "",
                "fieldtype_name": "",
                "indexes":"",
                "max_value":0,
                "decimal_places":0,
                "fields": [],
                "field_expression":""
            }

        if(ind !== "") {
            let indArr = ind.split(",");
            let cleanArr = indArr.filter((a) => a);
            let str = 'data.';
            cleanArr.map((item,iInd) => {
                str += cleanArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
            })
            let dat = eval(str);
            dat.fields.push(addArrayElementRow); 
            setArrayIndexes(data);  
            setPayload(data);
        }else {
            console.log(data);
            data.fields.push(addArrayElementRow);   
            setArrayIndexes(data);
            setPayload(data);
        }
    }

    const deleteArrayRow = (ind,id) => {
        const data = {...payload};
        let indArr = ind.split(",");
        let cleanArr = indArr.filter((a) => a);
        console.log(ind,id);
        if(id && id!== "") {
            props.Loader(true);
            callDELETE("variable/field/"+id+"/delete")
            .then(response => {
                props.Loader(false);
                const responseData = response.data;
                if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
                    if(cleanArr.length === 1) {
                        data.fields.splice(cleanArr[0], 1); 
                    }else {
                        let lastElement = cleanArr[cleanArr.length - 1];
                        // cleanArr = cleanArr.pop();
                        let newArr = [];
                        newArr.push.apply(newArr, cleanArr);
                        newArr.pop();
                        // console.log(cleanArr,lastElement,newArr)
                        let str = 'data.';
                        newArr.map((item,iInd) => {
                            str += newArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
                        })
                        let dat = eval(str);
                        dat.fields.splice(lastElement, 1); 
                    }
                    setArrayIndexes(data);  
                    setPayload(data);
                }else {
                  props.failMessage(responseData.message);
                }
            })

        }else {
            if(cleanArr.length === 1) {
                data.fields.splice(cleanArr[0], 1); 
            }else {
                let lastElement = cleanArr[cleanArr.length - 1];
                // cleanArr = cleanArr.pop();
                let newArr = [];
                newArr.push.apply(newArr, cleanArr);
                newArr.pop();
                // console.log(cleanArr,lastElement,newArr)
                let str = 'data.';
                newArr.map((item,iInd) => {
                    str += newArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
                })
                let dat = eval(str);
                dat.fields.splice(lastElement, 1); 
            }
            setArrayIndexes(data);  
            setPayload(data);
        }
        
        
    }

    

    const collapseAllHandler = () => {
        $('.collapseRole').hide(300);
        $('ul li').children('span')
                        .removeClass('minus');
        $('ul li').children('span')
                        .addClass('plus');
    }

    const expandAllHandler = () => {
        $('.collapseRole').show(300);
        $('ul li').children('span')
                        .removeClass('plus');
        $('ul li').children('span')
                        .addClass('minus');
    }

    const changeHandler = (e) => {
        const { name,value } = e.target;
        const list = {...payload}
        let regExp = /[a-zA-Z]/g;

        if(name === 'fieldtype_id') {
            const fieldName = e.target.selectedOptions[0].text;
            console.log(fieldName);
            list['constant_value'] = '';
            list['fieldtype_name'] = fieldName;
        }

        if(name === 'constant_value' && list['fieldtype_name'] === 'Decimal'){
            if(!regExp.test(value)) {
                if(value.indexOf('.') !== -1) {
                    if ((value.substring(value.indexOf('.')).length - 1) <= payload.decimal_places){
                        list[name] = value;
                    }
                }else {
                    list[name] = value;
                }
            }
        }else if(name === 'max_value' || name === 'decimal_places') { 
            list['constant_value'] = '';
            list[name] = value;   
        }else {
            list[name] = value;    
        }
        if (name=='variable_name') {
            let removeViolation=violations.filter(item=>item.field_name!='name')
            setViolations(removeViolation);
         }
         if (name=='fieldtype_id') {
             let removeViolation=violations.filter(item=>item.field_name!='type');
             setViolations(removeViolation);
         }
        
        setPayload(list);
    }
    const onChangeValueHandler = (key,value)=>{
        setPayload({...payload,[key]:value});
    }

    const saveHandler = () => {
        const params = props.match.params;
        console.log("RateCalculation Save ","params",params);
        props.Loader();
        const body = {
            id:payload.id,
            variable_name : payload.variable_name,
            variable_type : payload.variable_type,
            reference_id:params.calculationId,
            is_constant : payload.is_constant,
            constant_value : payload.constant_value,
            fieldtype_id : payload.fieldtype_id,
            fieldtype_name: payload.fieldtype_name,
            rateconfiguration_id : params.calculationId,
            max_value : payload.fieldtype_name === 'Decimal' ? payload.max_value : 0,
            decimal_places : payload.fieldtype_name === 'Decimal' ? payload.decimal_places : 0,
            fields: payload.fields,
            function_type:'RATES',
            is_response:payload.is_response,
            is_request:payload.is_request,
            field_expression:payload.field_expression,
            // ratesheet_id : payload.ratesheet_id
        }
        //console.log('body payload===',body); return false;
        callPOST("variable/save",body)
          .then(response => {
            props.Loader();
            console.log(response);
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
              // props.history.push("/workflow");
              props.succMessage(responseData.message);
              setPayload({
                    variable_name : '',
                    variable_type : 'LOCAL',
                    is_constant : false,
                    constant_value : null,
                    fieldtype_id : '',
                    ratesheet_id : '',
                    fieldtype_name : '',
                    max_value : 1,
                    decimal_places : 0,
                    fields: [],
                    function_type:'RATES',
                    is_response:false,
                    is_request:true,
                    field_expression:''                                        
                })
              props.saveHandler();
            }
            else if (responseData.code===400){
                if (responseData.violations) {
                   let violations= [];
                   responseData.violations.map(item=>{
                    violations.push(item);
                   })
                   setViolations(violations);
                }
            }
            else {              props.failMessage(responseData.message);
            }
          })
          .catch(err => {
            props.Loader();
            props.failMessage("Error occured");
            console.log(err);
          })
    }

    const updateHandler = () => {
        const params = props.match.params;
        props.Loader();
        const body = {
            constant_value : payload.constant_value,
            max_value : payload.fieldtype_name === 'Decimal' ? payload.max_value : 0,
            decimal_places : payload.fieldtype_name === 'Decimal' ? payload.decimal_places : 0
        }
        console.log(JSON.stringify(body));
        callPUT("rates/variables/"+payload.id+"/update",body)
          .then(response => {
            props.Loader();
            console.log(response);
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
              // props.history.push("/workflow");
              props.succMessage(responseData.message);
              setPayload({
                    variable_name : '',
                    variable_type : 'LOCAL',
                    is_constant : false,
                    constant_value : null,
                    fieldtype_id : '',
                    ratesheet_id : '',
                    fieldtype_name : '',
                    max_value : 1,
                    decimal_places : 0,
                    fields: [{
                        "name": "",
                        "field_type_id": "",
                        "fieldtype_name": "",
                        "indexes":"",
                        "max_value":0,
                        "decimal_places":0,
                        "fields": [],
                        "field_expression":""
                    }],
                    function_type:'RATES',
                    is_response:false,
                    is_request:true,
                    field_expression:''
                })
              props.saveHandler();
            }else {
              props.failMessage(responseData.message);
            }
          })
          .catch(err => {
            props.Loader();
            props.failMessage("Error occured");
            console.log(err);
          })
    }

    const toggleModel = () => {
        setPayload({
            variable_name : '',
            variable_type : 'LOCAL',
            is_constant : false,
            constant_value : null,
            fieldtype_id : '',
            ratesheet_id : '',
            fieldtype_name : '',
            max_value : 1,
            decimal_places : 0,
            fields: [],
            function_type:'RATES',
            is_response:false,
            is_request:true,
            field_expression:''
        })

        setErrorDefaultFields([
            {
              "name": "type",
              "field_type_id": "",
              "fieldtype_name": "",
              "indexes": ",0",
              "max_value": 0,
              "decimal_places": 0,
              "fields": [],
              "field_expression": "",
              "displayPosition": 1
            },
            {
              "name": "message",
              "field_type_id": "",
              "fieldtype_name": "",
              "indexes": ",1",
              "max_value": 0,
              "decimal_places": 0,
              "fields": [],
              "field_expression": "",
              "displayPosition": 2
            }
        ])
        setIsEdit(false);
        props.toggleModel();
        setViolations([])   
    }
    const generateWindowFields = (windowId) => {
        if(isSet(windowFields[windowId],null)===null){
          http.GET('field-groups/window/'+windowId+'/lookup-layouts')
          .then(windowResponse => {
            //   this.props.Loader(false);
              const responseData = windowResponse.data;
              if(responseData.code === 200) {
                setWindowFields({
                    ...windowFields,
                    [windowId]:responseData.data
                });
              }
          }, (error) => {
              console.log(error);
            //   this.props.Loader(false);
          })
        }    
      }

    const arrayValueChangeHandler = (name,value) => {
        console.log(name,value);
        const list = {...payload};
        if(name === 'arrayKey') {
            list.array_value[name] = "";
        }else {
            list.array_value[name] = value;
        }
        setPayload(list);
    }


    const checkThisIsErrorFieldType = () => {        
        
        const list = {...payload};
        //console.log('ErrorDefaultFields===',ErrorDefaultFields)

        if(isSet(list.id,null)===null){
            if(list.fieldtype_name==='Messages'){
                let field_type_id = '';
                let fieldtype_name = 'TextInput';
                list['fields'] = errorDefaultFields;
                if(isSet(variablesAndFields.field_type,[]).length>0){                    
                    const fieldTypeIndexByName = variablesAndFields.field_type.findIndex(i=>i.type_name===fieldtype_name);                                        
                    if(fieldTypeIndexByName!==-1){
                        field_type_id = variablesAndFields.field_type[fieldTypeIndexByName].id;
                    }
                    list['fields'][0]['field_type_id'] = field_type_id;
                    list['fields'][0]['fieldtype_name'] = fieldtype_name;
                    list['fields'][1]['field_type_id'] = field_type_id;
                    list['fields'][1]['fieldtype_name'] = fieldtype_name;  
                }
                setPayload(list);
                props.toogleArrayElementModel();
            }else{
                props.toogleArrayElementModel();    
            }
        }else{
            props.toogleArrayElementModel();
        }
    }

    const max_value_cnt = 16;
    let decimal_cnt = 0;
    if(parseInt(payload.max_value) > 10) {
        decimal_cnt = 10
    }else {
        decimal_cnt = parseInt(payload.max_value);
    }
    let constantAttributes={}
    if(payload.fieldtype_name === 'Decimal'){
        constantAttributes={
            maxLength:payload.max_value,
            decimal:payload.decimal_places
        }
    }
    let variableTypeTitle = 'Variable';
    if(props.currentTabToShow === 'variable'){
        variableTypeTitle = 'Variable';
    }else{
        variableTypeTitle = 'Constant';
    }
    
    let arrayKeys = [];
    if(payload.array_value && payload.array_value !== null) {
         Object.keys(payload.array_value).map(function(key) {
            arrayKeys.push(key);
        })
    }

    const updatePayload = (updatePayload) => {
        setPayload(updatePayload);    
    }

    const headerTabsList = [
        {
            name:"Input Variable",
            attributes:{
              "aria-selected":false,
              className:(payload.is_request===true)? "nav-link submenu active show" : "nav-link" 
            },
            access_mode:true,
            clickHandler:()=>(isSet(payload.id,null)!==null)?{}:updatePayload({...payload,is_request:true,is_response:false,is_constant:false})
        },
        {
            name:"Output Variable",
            attributes:{
              "aria-selected":false,
              className:(payload.is_response===true)? "nav-link submenu active show" : "nav-link" 
            },
            access_mode:true,
            clickHandler:()=>(isSet(payload.id,null)!==null)?{}:updatePayload({...payload,is_request:false,is_response:true,is_constant:false})
        },
        {
            name:"Constant",
            attributes:{
              "aria-selected":false,
              className:(payload.is_constant==true)? "nav-link submenu active show" : "nav-link" 
            },
            access_mode:true,
            clickHandler:()=>(isSet(payload.id,null)!==null)?{}:updatePayload({...payload,is_request:false,is_response:false,is_constant:true})
        }        
    ];

	return (
		<Modal size="lg" show={props.modelOpen}>
            <Modal.Header>
                {/*<h6 className="modal-title secondary_color mb-0"> {isEdit === true ? 'Update' : 'Create'} {variableTypeTitle} </h6>*/}
                <HeaderTabs 
                    attributes={{className:"nav nav-pills navcrm-primary nav-pills-no-bd"}} 
                    headerTabsList={headerTabsList}
                />
            </Modal.Header>
            <Modal.Body>

                <div className="row">

                    <div className="col-12">
                        <div className="form-group">
                            <label> {payload.is_constant===true?'Constant':'Variable'} Name</label>
                            <input type="text" className="form-control" name="variable_name" value={payload.variable_name} onChange={changeHandler} disabled={isEdit}/>
                        </div>
                        {violations.map((itm, index) => {
                                if (itm.field_name === "name") {
                                    return <ErrorBlock key={index} message={itm.message} />;
                                }
                                return null; 
                                })}
                    </div>

                    <div className="col-12">
                        <div className="form-group">
                            <label> Field Type </label>
                            {/*<option value=""></option>*/}
                            <select className="form-control custom-arrow" name="fieldtype_id" value={payload.fieldtype_id} onChange={changeHandler} disabled={isEdit}>
                                <option value=""></option>
                            {
                                variablesAndFields ? 
                                    variablesAndFields.field_type ?
                                        variablesAndFields.field_type.map((arr,i) => {
                                            return <option key={i} value={arr.id}>{arr.type_name}</option>
                                        })
                                    : null
                                : null
                            }
                            </select>
                            {violations.map((itm, index) => {
                                if (itm.field_name === "type") {
                                    return <ErrorBlock key={index} message={itm.message} />;
                                }
                                return null; 
                                })}
                        </div>
                    </div>

                    { payload.fieldtype_name === 'Decimal' ? 
                        <Wrp>
                            <div className="col-12">
                                <div className="form-group">
                                    <label> Max Digits </label>
                                    <select className="form-control custom-arrow" name="max_value" value={payload.max_value} onChange={changeHandler}>
                                    { [...Array(max_value_cnt)].map((elementInArray, index) => ( 
                                                <option key={index} value={index + 1}>{index + 1}</option>
                                            ) 
                                    ) }
                                    </select>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label> Decimal </label>
                                    <select className="form-control custom-arrow" name="decimal_places" value={payload.decimal_places} onChange={changeHandler}>
                                        {[...Array(decimal_cnt)].map((elementInArray, index) => ( 
                                                    <option key={index} value={index}>{index}</option>
                                                ) 
                                        )}
                                    </select>
                                </div>
                            </div>
                        </Wrp>
                    : (ShipConstants.VARIABLE_CONSTANT_TYPE.indexOf(payload.fieldtype_name) !== -1 )? 
                        <div className="col-12 mb-2">
                            <a className="cursor-pointer" onClick={checkThisIsErrorFieldType}>
                                <span className="svgIcon"> <Icons iconType="AddPlusTwo" /> </span> Add {payload.fieldtype_name} Element
                            </a>
                        </div>
                       
                    : null }

                    {payload.is_constant === true && payload.fieldtype_name !== 'Array' ?
                        <div className="col-12">
                            <div className="form-group">
                                <label> Constant Value </label>
                                <FormInputFields 
                                    type={formInputFieldsKeyRef(payload.fieldtype_name)}
                                    attributes={{
                                        ...constantAttributes,
                                        // id:'constantValue',
                                        id:'constantValue',
                                        // getDateFormat:getDateFormat('DateTime')
                                    }}
                                    isDefault={formInputFieldsKeyRef(payload.fieldtype_name)==='Checkbox'?false:true}
                                    changeHandler={(val)=>onChangeValueHandler('constant_value',val)}
                                    value={payload.constant_value}
                                />
                                
                            </div>
                        </div>
                    : null }
                    <div className="col-12">
                        <div className="form-group">
                            <label> Variable Type </label>
                            <select className="form-control custom-arrow" name="variable_type" value={payload.variable_type} onChange={changeHandler} disabled={isEdit}>
                            <option value="LOCAL">LOCAL</option>
                            <option value="GLOBAL">GLOBAL</option>
                            </select>
                        </div>
                    </div>

                </div>
 
            </Modal.Body>

            <Modal.Footer>
                
                    <a onClick={toggleModel} className="btn btn-cancel mr-2" data-dismiss="modal"> Cancel </a> 
                    <a onClick={payload.id ? saveHandler : saveHandler } className="btn primary_bg" data-dismiss="modal"> {isEdit === true ? 'Update' : 'Add'} </a> 
                
            </Modal.Footer>

            <ArrayElement
              toogleArrayElementModel={props.toogleArrayElementModel}
              arrayElement={payload}
              changeHandler={arrayChangeHandler}
              addRow={addArrayRow}
              deleteRow={deleteArrayRow}
              collapseAllHandler= {collapseAllHandler} 
              expandAllHandler={expandAllHandler} 
              isArrayElementModalOpen={curState.isArrayElementModalOpen}
              variablesAndFields={curState.variablesAndFields}
              currentTab={(isSet(payload.window_id,null)!==null)?'VARIABLE':curState.currentTab}
              >
              {(payload.fieldtype_name==='Object' || payload.fieldtype_name=='Array')?
                  <WindowMapFields 
                      generateWindowFields={generateWindowFields}
                      variablesAndFields={variablesAndFields.field_type}
                      isAssignFieldOnly={'ALL'} 
                      windowsList={props.windowsList.map((item)=>{
                        return{
                            value:item.window_name,
                            id:item.id,
                            label:item.window_name
                        }
                      })}
                      windowFields={windowFields}
                      updateWindowId={(winId)=>setPayload({...payload,'window_id':winId})}
                      updateFields={(fields)=>setPayload({...payload,'fields':fields})}
                      payload={payload}/>
              :<></>}
              
            </ArrayElement>
            
		</Modal>
	);
}

const mapDispatchToProps = dispatch => {
    return {
      Loader : () => dispatch(actions.loader()),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg))      
    };
}
export default
    connect(
      null, 
      mapDispatchToProps
    )(withRouter(CreateNew));